import React from 'react'
import styled from 'styled-components'
import ApplicationSliderOriginal from './ApplicationsSlider'
import { device } from '../style'
import ScrollManager from '../components/ScrollManager'
import InspirationMode from './InspirationMode/InspirationMode'
import ConstelaUI from './ConstelaUI/ConstelaUI'
import { useSelector } from '../store/hooks'
import ExpertMode from './ExpertMode/ExpertMode'

const ApplicationSlider = styled(ApplicationSliderOriginal)`
  height: calc(100vh - 55px);
  min-height: calc(100vw * 1.4 - 55px);

  @media ${device.laptop} {
    min-height: calc(100vw * 9 / 16 - 55px);
  }
`

const Main: React.FC = () => {
  const mode = useSelector((state) => state.ui.mode)
  return (
    <ScrollManager>
      <ApplicationSlider key="slider" />
      <ConstelaUI key="ui">
        {mode === 'inspiration' ? <InspirationMode key="inspiration-mode" /> : <ExpertMode key="export-mode" />}
      </ConstelaUI>
    </ScrollManager>
  )
}

export default Main
